import React from 'react';
import PropTypes from 'prop-types';
import { getTalents, mapTalentToSpecialRibbonProps } from '../fichaHelper';
import SpecialRibbon from '../../RibbonNew/SpecialRibbon';
class VCardTalents extends React.PureComponent {
    render(){
        const {roles, externalrole, setMetricsEvent, handleTalentClick =()=>{}, user, content_name } = this.props;
        const talents = externalrole ? externalrole : getTalents(roles, handleTalentClick );
        if(!Array.isArray(talents) ||  talents.length === 0){
            return null;
        }
        const ribbonProps = mapTalentToSpecialRibbonProps(talents, content_name);
        
        return (
            <div className="vcard-talents">
                <SpecialRibbon
                    {...ribbonProps}
                    user={user}
                    setMetricsEvent={setMetricsEvent}
                />
            </div>
        )
    }
}

VCardTalents.propTypes = {
    roles: PropTypes.array.isRequired,
    externalrole: PropTypes.object,
    setMetricsEvent: PropTypes.func.isRequired,
    handleTalentClick: PropTypes.func.isRequired
}

VCardTalents.defaultProps = {
    roles: [],
    externalrole: null,
    setMetricsEvent: ()=>{},
    handleTalentClick:()=>{}
}

export default VCardTalents;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardTalents.jsx